import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const postAppointment = (data) => axios.post(`${API}/appointments`, data).then((r) => r.data);
export const postFranchise = (data) => axios.post(`${API}/franchise-inquiries`, data).then((r) => r.data);
